import { WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT, WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE } from '../constants/we-spin-text-keys.js';
import {
	WE_SPIN_DASHBOARD_TAB_ITEM_BALANCE_DATA_AT,
	WE_SPIN_DASHBOARD_TAB_ITEM_CHAT_DATA_AT
} from '../constants/we-spin-data-at-attributes';

const WE_SPIN_GAME_ROOM_TAB_ITEMS = [
	{
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_BALANCE_DATA_AT
	},
	{
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_CHAT_DATA_AT
	}
];

export default WE_SPIN_GAME_ROOM_TAB_ITEMS;
